export const styles = {
    appBackground: "#FFFFFF",
    backgrounds: [
        { className: "primary-bg-colour", colour: "#004B23" },
        { className: "secondary-bg-colour", colour: "#FFFFFF" },
        { className: "tertiary-bg-colour", colour: "#F5F5F5" },
        { className: "inactive-bg-colour", colour: "#E5E5E5" },
        { className: "misc-bg-colour", colour: "#4444441f" },
    ],
    text: [
        { className: "primary-text", colour: "#000000" },
        { className: "secondary-text", colour: "#FFFFFF" },
        { className: "tertiary-text", colour: "#000000" },
        { className: "inactive-text", colour: "#B6B6B6" },
        { className: "misc-text", colour: "#004B23" },
    ],
    contextualText: [
        { parentClassName: "primary-bg-colour", className: "primary-text", colour: "#FFFFFF", fontWeight: "700" },
    ],
    borders: [
        { className: "primary-border-colour", colour: "#004B23" },
        { className: "secondary-border-colour", colour: "#E1DDDD" },
        { className: "primary-free-border-colour", colour: "#44444440" },
    ],
};
